<script>
    import "../../../../../app.css";
    import MetricsRow from "./metrics_row.svelte";
    import { t } from "$lib/i18n.js";
</script>

<section>
    <div class="headline">
    <h2>
        {$t("routes.owner.metrics.title")}
    </h2>
    <h2 class="water-green"> {$t("routes.owner.metrics.title_accent")}</h2>
    </div>
    <div class="mockup">
        <img src="https://assets.auting.it/images/mockups/phones.webp" alt="Metrics Mockup" />
    </div>
    <div class="up">
    <MetricsRow />
    </div>
</section>

<style>
    section {
        background: var(--surface);
        padding-top: 120px;
    }

    .mockup {
        width: 100%;
        height: 520px;
        background: var(--surface);
        background: #5bb6bc;
        padding-top: 24px;
        background: -webkit-linear-gradient(
            0deg,
            rgba(245, 243, 237, 0.5) 0%,
            rgba(255, 255, 255, 1) 100%
        );
        background: -moz-linear-gradient(
            0deg,
            rgba(245, 243, 237, 0.5) 0%,
            rgba(255, 255, 255, 1) 100%
        );
        background: linear-gradient(
            0deg,
            rgba(245, 243, 237, 0.5) 0%,
            rgba(255, 255, 255, 1) 100%
        );
        filter: progid:DXImageTransform.Microsoft.gradient(startColorstr="#FFFFFF", endColorstr="#F5F3ED", GradientType=0);
    }

    .mockup img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        object-position: center;
        z-index: 0;
        position: relative;
    }

    .headline {
        max-width: 550px;
        margin: auto;
    }

    h2 {
        margin: 0;
        padding: 0;
        text-align: center;
        font-family: var(--font-body);
    }

    h2.water-green {
        color: var(--water-green);
        font-family: var(--font-heading);
        margin-top: 8px;
    }

    @media (max-width: 768px) {
        section {
            padding-top: 80px;
        }

        .mockup {
            height: 400px;
        }

        h2 {
            font-size: 40px;
            letter-spacing: -2px;
        }
    }
</style>
